import { useQueryClient } from '@tanstack/react-query';
import { Lock } from 'lucide-react';
import { useEffect, type ReactElement, type ReactNode } from 'react';

import { StatePanel } from './StatePanel';

/** Estado "sin acceso" ante un 403: explica sin ofrecer reintentar (no cambiaría nada) y
 *  refresca /me para que el menú deje de ofrecer lo que ya no está permitido, p. ej. un
 *  acceso temporal de proveedor que venció. */
export function NoAccessPanel({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}): ReactElement {
  const qc = useQueryClient();
  useEffect(() => {
    void qc.invalidateQueries({ queryKey: ['me'] });
  }, [qc]);
  return (
    <StatePanel icon={<Lock />} title={title} role="alert" className={className}>
      {children}
    </StatePanel>
  );
}
